import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cookies from "js-cookie";

import AppRoutes from "./routes/AppRoutes";

// CSS Personalizado de Tabler
import "@tabler/core/dist/css/tabler.min.css";
import "@tabler/core/dist/js/tabler.min.js";

// CSS Global
import "./assets/style/Global.css";
import "./assets/style/LoadAllPage.css";
import "./assets/style/LoadCarga.css";

function App() {
  const [jwtToken, setJwtToken] = useState(Cookies.get("token"));

  useEffect(() => {
    const checkToken = () => setJwtToken(Cookies.get("token"));
    window.addEventListener("storage", checkToken);
    return () => window.removeEventListener("storage", checkToken);
  }, []);

  return (
    <Router>
      <div className="page">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
